/**
 * Base URL for Chat ABAP endpoints (`/chat/*`).
 * Prefer REACT_APP_VIBE_CODING_STUDIO_URL (gateway → aistudioapi).
 * Falls back to REACT_APP_BACKEND_URL for legacy nginx alias.
 *
 * Values are read from window.__ENV__ (injected at deploy time via config.js)
 * with fallback to process.env for local development.
 */
import { VIBE_CODING_STUDIO_URL, BACKEND_URL } from "@/lib/env";

export const VIBE_CHAT_API_BASE = (VIBE_CODING_STUDIO_URL || BACKEND_URL)
  .trim()
  .replace(/\/$/, '');
